// Coverage sources and selection notes: FileIconCoverage.json.
export const FILE_ICON_GROUPS = [
  {
    id: "documents",
    extensions: [
      "adoc",
      "asciidoc",
      "azw",
      "azw3",
      "bib",
      "bmml",
      "cba",
      "cbt",
      "cdf",
      "cst",
      "djv",
      "doc",
      "docm",
      "docx",
      "dot",
      "dotm",
      "dotx",
      "dsc",
      "eml",
      "epub",
      "fb2",
      "fcdt",
      "fdx",
      "flo",
      "fm",
      "fodt",
      "gdoc",
      "gform",
      "gsite",
      "ics",
      "kfx",
      "ltf",
      "man",
      "max",
      "mbox",
      "md",
      "me",
      "mif",
      "mobi",
      "mpd",
      "msg",
      "odm",
      "odt",
      "one",
      "org",
      "ost",
      "ott",
      "oxps",
      "pages",
      "pcl",
      "pdf",
      "ps",
      "pst",
      "pub",
      "qxp",
      "ris",
      "rpt",
      "rst",
      "rtf",
      "scriv",
      "smf",
      "tex",
      "txt",
      "typ",
      "vcf",
      "wpd",
      "wps",
      "xps",
    ],
  },
  {
    id: "spreadsheets",
    extensions: [
      "123",
      "csv",
      "fods",
      "gnumeric",
      "iqy",
      "numbers",
      "ods",
      "ots",
      "sxc",
      "tsv",
      "xla",
      "xlam",
      "xlr",
      "xls",
      "xlsb",
      "xlsm",
      "xlsx",
      "xlt",
      "xltm",
      "xltx",
    ],
  },
  {
    id: "presentations",
    extensions: [
      "fodp",
      "key",
      "odp",
      "otp",
      "pot",
      "potm",
      "potx",
      "pps",
      "ppsm",
      "ppsx",
      "ppt",
      "pptm",
      "pptx",
    ],
  },
  {
    id: "images",
    extensions: [
      "ani",
      "apng",
      "arw",
      "avif",
      "bmp",
      "cr2",
      "cr3",
      "cur",
      "dcm",
      "dds",
      "dib",
      "djvu",
      "dng",
      "exr",
      "fits",
      "fpx",
      "gbr",
      "gif",
      "gim",
      "heic",
      "heif",
      "icns",
      "ico",
      "j2k",
      "jls",
      "jp2",
      "jpe",
      "jpeg",
      "jpf",
      "jpg",
      "jpx",
      "jxl",
      "mng",
      "msp",
      "nef",
      "nrw",
      "orf",
      "pbm",
      "pcx",
      "pef",
      "pgm",
      "pm",
      "png",
      "ppm",
      "qoi",
      "raf",
      "raw",
      "rw2",
      "srw",
      "svg",
      "tga",
      "tif",
      "tiff",
      "webp",
      "xbm",
      "xpm",
    ],
  },
  {
    id: "audio",
    extensions: [
      "aac",
      "ac3",
      "adts",
      "aif",
      "aifc",
      "aiff",
      "alac",
      "als",
      "amr",
      "ape",
      "aup",
      "aup3",
      "band",
      "caf",
      "cue",
      "flac",
      "flp",
      "gsf",
      "it",
      "logicx",
      "m2a",
      "m3a",
      "m3u",
      "m3u8",
      "m4a",
      "m4b",
      "m4r",
      "mid",
      "midi",
      "mka",
      "mp1",
      "mp2",
      "mp2a",
      "mp3",
      "mp4a",
      "mpa",
      "mpc",
      "mpga",
      "mscx",
      "mscz",
      "mus",
      "mxl",
      "nsf",
      "oga",
      "ogg",
      "opus",
      "ra",
      "ram",
      "rip",
      "s3m",
      "saf",
      "sf2",
      "spx",
      "svd",
      "wav",
      "wax",
      "weba",
      "wma",
      "wv",
      "xm",
    ],
  },
  {
    id: "video",
    extensions: [
      "3g2",
      "3gp",
      "aep",
      "asf",
      "ass",
      "avi",
      "dir",
      "dxr",
      "fcp",
      "flv",
      "m2ts",
      "m2v",
      "m4s",
      "m4u",
      "m4v",
      "mj2",
      "mkv",
      "mov",
      "mp4",
      "mpeg",
      "mpg",
      "mts",
      "mxf",
      "ogm",
      "ogv",
      "pac",
      "qt",
      "rm",
      "rms",
      "rmvb",
      "sbv",
      "ser",
      "siv",
      "smv",
      "srt",
      "ssa",
      "str",
      "sub",
      "swf",
      "swi",
      "ttml",
      "veg",
      "vob",
      "vtt",
      "webm",
      "wmv",
      "wpl",
    ],
  },
  {
    id: "archives",
    extensions: [
      "7z",
      "abk",
      "arc",
      "arj",
      "bpk",
      "br",
      "bz",
      "bz2",
      "cb7",
      "cbr",
      "cbz",
      "cpio",
      "enc",
      "f",
      "gz",
      "ice",
      "lz",
      "lz4",
      "lzma",
      "lzo",
      "mbk",
      "mim",
      "mpkg",
      "rar",
      "sfs",
      "sis",
      "sit",
      "sitx",
      "spf",
      "tar",
      "tar.gz",
      "tbz",
      "tbz2",
      "tgz",
      "tmp",
      "txz",
      "uue",
      "xapk",
      "xz",
      "z",
      "zip",
      "zipx",
      "zst",
    ],
  },
  {
    id: "code",
    extensions: [
      "appcache",
      "asm",
      "asp",
      "aspx",
      "astro",
      "bash",
      "bat",
      "c",
      "cc",
      "cfm",
      "chat",
      "chm",
      "cjs",
      "class",
      "clj",
      "cljc",
      "cljs",
      "cmake",
      "cmd",
      "cod",
      "coffee",
      "config",
      "cpp",
      "cs",
      "csh",
      "csp",
      "css",
      "cts",
      "cu",
      "cxx",
      "dart",
      "dcr",
      "def",
      "dtd",
      "edn",
      "erl",
      "ex",
      "exs",
      "f90",
      "fish",
      "fs",
      "fsi",
      "fsx",
      "gmx",
      "go",
      "gql",
      "gradle",
      "graphql",
      "groovy",
      "h",
      "hbs",
      "hh",
      "hpp",
      "hs",
      "htc",
      "htm",
      "html",
      "hxx",
      "in",
      "ipynb",
      "java",
      "js",
      "json5",
      "jsp",
      "jsx",
      "kt",
      "kts",
      "less",
      "lua",
      "m",
      "markdown",
      "mdx",
      "mjs",
      "mm",
      "mml",
      "mxml",
      "nix",
      "pas",
      "php",
      "pl",
      "proto",
      "ps1",
      "psd1",
      "psm1",
      "pwn",
      "py",
      "pyi",
      "r",
      "rb",
      "rmd",
      "rproj",
      "rs",
      "s",
      "sass",
      "sb3",
      "sc",
      "scss",
      "sh",
      "shtml",
      "sln",
      "so",
      "sol",
      "svelte",
      "swift",
      "tf",
      "tfvars",
      "tpl",
      "ts",
      "tsx",
      "vb",
      "vcxproj",
      "vue",
      "wbs",
      "webmanifest",
      "xaml",
      "xcodeproj",
      "xhtm",
      "xhtml",
      "xsd",
      "xul",
      "ymp",
      "zig",
      "zsh",
    ],
  },
  {
    id: "data",
    extensions: [
      "aae",
      "aam",
      "acc",
      "accdb",
      "adp",
      "application",
      "arrow",
      "atc",
      "avro",
      "brushset",
      "bson",
      "cdx",
      "ckpt",
      "clkk",
      "clp",
      "conf",
      "crd",
      "crdownload",
      "crypt14",
      "db",
      "db3",
      "dbf",
      "env",
      "fcs",
      "feather",
      "flw",
      "fsc",
      "gdraw",
      "ggb",
      "gguf",
      "gxt",
      "h5",
      "hdf",
      "hdf5",
      "icm",
      "ini",
      "ink",
      "jad",
      "jam",
      "jph",
      "json",
      "jsonl",
      "kpr",
      "lock",
      "log",
      "mat",
      "mdb",
      "mdf",
      "mpp",
      "msf",
      "msgpack",
      "mwf",
      "ndf",
      "ndjson",
      "nitf",
      "nomedia",
      "npy",
      "npz",
      "obb",
      "odb",
      "odf",
      "onetoc2",
      "onnx",
      "orc",
      "ova",
      "ovf",
      "p10",
      "parquet",
      "pdb",
      "pickle",
      "pkl",
      "pkpass",
      "plf",
      "properties",
      "psf",
      "pt",
      "pth",
      "rdata",
      "rdf",
      "rds",
      "res",
      "safetensors",
      "set",
      "sfv",
      "sisx",
      "snf",
      "sql",
      "sqlite",
      "sqlite3",
      "td",
      "teacher",
      "tflite",
      "toml",
      "torrent",
      "trm",
      "txd",
      "vbox",
      "vcs",
      "wtb",
      "xlf",
      "xml",
      "yaml",
      "yml",
    ],
  },
  {
    id: "design",
    extensions: [
      "3dm",
      "3ds",
      "3mf",
      "aepx",
      "afdesign",
      "afphoto",
      "afpub",
      "ai",
      "ase",
      "aseprite",
      "bak",
      "blend",
      "c4d",
      "cdr",
      "cfg",
      "cmx",
      "dae",
      "dgn",
      "drawio",
      "drp",
      "dwf",
      "dwfx",
      "dwg",
      "dxf",
      "emf",
      "emz",
      "eps",
      "f3d",
      "f3z",
      "fbx",
      "fcpxml",
      "fh4",
      "fh7",
      "fig",
      "glb",
      "gltf",
      "idml",
      "ifc",
      "igs",
      "indd",
      "kra",
      "ma",
      "mb",
      "mesh",
      "msm",
      "mxs",
      "nc",
      "obj",
      "odg",
      "otg",
      "part",
      "pmd",
      "prc",
      "prproj",
      "psb",
      "psd",
      "resolve",
      "sketch",
      "skp",
      "sldasm",
      "slddrw",
      "sldprt",
      "std",
      "step",
      "stl",
      "stp",
      "svgz",
      "unity",
      "usd",
      "usda",
      "usdc",
      "usdz",
      "vox",
      "vsd",
      "vsdx",
      "vstx",
      "w3d",
      "wmf",
      "x3d",
      "xcf",
    ],
  },
  {
    id: "applications",
    extensions: [
      "aab",
      "ac",
      "air",
      "apk",
      "app",
      "appimage",
      "appx",
      "appxbundle",
      "bin",
      "cfs",
      "cif",
      "com",
      "crx",
      "deb",
      "dmg",
      "dylib",
      "ear",
      "ecf",
      "elf",
      "exe",
      "flatpak",
      "fxp",
      "img",
      "ipa",
      "iso",
      "jar",
      "msi",
      "msix",
      "nupkg",
      "oxt",
      "pkg",
      "plugin",
      "rpm",
      "run",
      "safariextz",
      "scm",
      "snap",
      "vbox-extpack",
      "vcd",
      "vdi",
      "vhd",
      "vmdk",
      "vsix",
      "vst",
      "wasm",
      "wcm",
      "whl",
      "x32",
      "xap",
      "xbap",
      "xlm",
      "xpi",
    ],
  },
  {
    id: "fonts",
    extensions: ["bdf", "eot", "fnt", "otc", "otf", "pfa", "pfb", "ttc", "ttf", "woff", "woff2"],
  },
  {
    id: "maps",
    extensions: [
      "atx",
      "bil",
      "geojson",
      "geotiff",
      "gmap",
      "gml",
      "gpkg",
      "gpx",
      "kml",
      "kmz",
      "osm",
      "qgs",
      "qgz",
      "shp",
      "shx",
      "ssf",
      "topojson",
    ],
  },
  {
    id: "games",
    extensions: [
      "bsp",
      "dat",
      "dem",
      "gam",
      "gba",
      "lrf",
      "map",
      "mpm",
      "nes",
      "pak",
      "pgn",
      "rep",
      "rom",
      "sav",
      "scs",
      "sgm",
      "sid",
      "sm",
      "smzip",
      "spc",
      "vtf",
      "wad",
      "z3",
      "z4",
    ],
  },
  {
    id: "system",
    extensions: [
      "aml",
      "cab",
      "cat",
      "cpl",
      "deskthemepack",
      "dll",
      "dmp",
      "drv",
      "lnk",
      "manifest",
      "nfo",
      "nt",
      "ppd",
      "reg",
      "sys",
    ],
  },
  {
    id: "security",
    extensions: [
      "asc",
      "cer",
      "crt",
      "csr",
      "der",
      "gpg",
      "jks",
      "keystore",
      "p12",
      "p7b",
      "p7c",
      "pem",
      "pfx",
      "pgp",
      "sig",
    ],
  },
] as const;

export const FILE_ICON_FILENAMES = ["dockerfile", "makefile"] as const;
